// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Codec_Argonaut from "../Data.Codec.Argonaut/index.js";
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Duration from "../Data.Duration/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Visonum_API_SpeedMaster from "../Visonum.API.SpeedMaster/index.js";
import * as Visonum_BulkPingApp_App_Error from "../Visonum.BulkPingApp.App.Error/index.js";
import * as Visonum_BulkPingApp_App_Header from "../Visonum.BulkPingApp.App.Header/index.js";
import * as Visonum_BulkPingApp_App_Login from "../Visonum.BulkPingApp.App.Login/index.js";
import * as Visonum_BulkPingApp_CSV from "../Visonum.BulkPingApp.CSV/index.js";
import * as Visonum_BulkPingApp_Components_App_Types from "../Visonum.BulkPingApp.Components.App.Types/index.js";
import * as Visonum_BulkPingApp_DetailsPanel from "../Visonum.BulkPingApp.DetailsPanel/index.js";
import * as Visonum_BulkPingApp_EditPanel from "../Visonum.BulkPingApp.EditPanel/index.js";
import * as Visonum_BulkPingApp_MainPanel from "../Visonum.BulkPingApp.MainPanel/index.js";
import * as Visonum_BulkPingApp_Util from "../Visonum.BulkPingApp.Util/index.js";
import * as Visonum_BulkPingApp_Views_Layout from "../Visonum.BulkPingApp.Views.Layout/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
import * as Web_Storage_Storage from "../Web.Storage.Storage/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var bind = /* #__PURE__ */ Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var monadEffectHalogenM = /* #__PURE__ */ Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff);
var error = /* #__PURE__ */ Effect_Class_Console.error(monadEffectHalogenM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(monadEffectHalogenM);
var top = /* #__PURE__ */ Data_Bounded.top(Data_Bounded.boundedInt);
var liftAff = /* #__PURE__ */ Effect_Aff_Class.liftAff(/* #__PURE__ */ Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff));
var log = /* #__PURE__ */ Effect_Class_Console.log(Effect_Class.monadEffectEffect);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Codec_Argonaut.showJsonDecodeError);
var Void = /* #__PURE__ */ (function () {
    function Void() {

    };
    Void.value = new Void();
    return Void;
})();
var stopPolling = /* #__PURE__ */ bind(get)(function (state) {
    return for_(state.pollingForkId)(function (forkId) {
        return discard(Halogen_Query_HalogenM.kill(forkId))(function () {
            return modify_(function (v) {
                var $46 = {};
                for (var $47 in v) {
                    if ({}.hasOwnProperty.call(v, $47)) {
                        $46[$47] = v[$47];
                    };
                };
                $46.pollingForkId = Data_Maybe.Nothing.value;
                return $46;
            });
        });
    });
});
var showError = function (title) {
    return function (message) {
        return discard(modify_(function (state) {
            var $49 = {};
            for (var $50 in state) {
                if ({}.hasOwnProperty.call(state, $50)) {
                    $49[$50] = state[$50];
                };
            };
            $49.displayError = new Data_Maybe.Just({
                title: title,
                message: message
            });
            return $49;
        }))(function () {
            return discard(error(message))(function () {
                return pure(Data_Unit.unit);
            });
        });
    };
};
var runSinglePoll = /* #__PURE__ */ bind(get)(function (v) {
    return bind(liftEffect(Effect_Random.randomInt(0)(top)))(function (c) {
        return bind(liftAff(Visonum_API_SpeedMaster.getBulkPingStatus(v.staticConfig.speedMasterUrl)(v.spmApiKey)({
            c: c
        })))(function (res) {
            return discard((function () {
                if (res instanceof Data_Either.Left) {
                    return liftEffect(log("Polling failed: " + show(res.value0)));
                };
                if (res instanceof Data_Either.Right) {
                    return modify_(function (state) {
                        var $55 = {};
                        for (var $56 in state) {
                            if ({}.hasOwnProperty.call(state, $56)) {
                                $55[$56] = state[$56];
                            };
                        };
                        $55.bulkPingStatus = res.value0;
                        return $55;
                    });
                };
                throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 262, column 3 - line 265, column 58): " + [ res.constructor.name ]);
            })())(function () {
                return pure(Data_Either.isRight(res));
            });
        });
    });
});
var $lazy_runPolling = /* #__PURE__ */ $runtime_lazy("runPolling", "Visonum.BulkPingApp.Components.App", function () {
    return discard(liftEffect(log("Polling for bulk ping jobs")))(function () {
        return bind(liftEffect(Effect_Now.now))(function (timeBefore) {
            return bind(runSinglePoll)(function () {
                return bind(liftEffect(Effect_Now.now))(function (timeAfter) {
                    var elapsedMs = unwrap(Data_DateTime_Instant.unInstant(timeAfter)) - unwrap(Data_DateTime_Instant.unInstant(timeBefore));
                    return discard(liftAff(Effect_Aff.delay(1000.0 - elapsedMs)))(function () {
                        return $lazy_runPolling(252);
                    });
                });
            });
        });
    });
});
var runPolling = /* #__PURE__ */ $lazy_runPolling(238);
var startPolling = /* #__PURE__ */ bind(/* #__PURE__ */ Halogen_Query_HalogenM.fork(runPolling))(function (forkId) {
    return modify_(function (state) {
        var $61 = {};
        for (var $62 in state) {
            if ({}.hasOwnProperty.call(state, $62)) {
                $61[$62] = state[$62];
            };
        };
        $61.pollingForkId = new Data_Maybe.Just(forkId);
        return $61;
    });
});
var render = function (state) {
    var ctx = {
        debug: true,
        staticConfig: state.staticConfig
    };
    return Halogen_HTML_Elements.div([  ])(Halogen_Styled.toHTML(ctx)(Visonum_BulkPingApp_Views_Layout.view({
        headerPanel: Visonum_BulkPingApp_App_Header.view(state),
        mainPanel: Visonum_BulkPingApp_MainPanel.view(state),
        editPanel: Visonum_BulkPingApp_EditPanel.view(state),
        detailsPanel: (function () {
            if (state.details instanceof Data_Maybe.Nothing) {
                return Data_Maybe.Nothing.value;
            };
            if (state.details instanceof Data_Maybe.Just) {
                return new Data_Maybe.Just(Visonum_BulkPingApp_DetailsPanel.view(state));
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 98, column 27 - line 100, column 55): " + [ state.details.constructor.name ]);
        })(),
        loginPanel: Visonum_BulkPingApp_App_Login.view(state),
        showLogin: (function () {
            if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginNotTried) {
                return true;
            };
            if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginChecking) {
                return true;
            };
            if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginSuccess) {
                return false;
            };
            if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginFailure) {
                return true;
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 102, column 24 - line 106, column 35): " + [ state.logInState.constructor.name ]);
        })(),
        error: (function () {
            if (state.displayError instanceof Data_Maybe.Nothing) {
                return Data_Maybe.Nothing.value;
            };
            if (state.displayError instanceof Data_Maybe.Just) {
                return new Data_Maybe.Just(Visonum_BulkPingApp_App_Error.view({
                    title: state.displayError.value0.title,
                    message: state.displayError.value0.message,
                    onClose: Visonum_BulkPingApp_Components_App_Types.HideError.value
                }));
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 107, column 20 - line 110, column 73): " + [ state.displayError.constructor.name ]);
        })()
    })));
};
var printDuration = /* #__PURE__ */ (function () {
    var $164 = Data_Number_Format.toStringWith(Data_Number_Format.fixed(2));
    var $165 = Data_Time_Duration.fromDuration(Data_Duration.durationDuration);
    return function ($166) {
        return $164(unwrap($165($166)));
    };
})();
var initialState = function (v) {
    return {
        bulkPingStatus: {
            jobs: Data_Map_Internal.empty
        },
        staticConfig: v.staticConfig,
        showNewJob: false,
        newJob: {
            agentUrl: "",
            pingCountPerIp: "3",
            intervalBetweenIpsMillis: "1000",
            intervalBetweenPingsMillis: "0",
            useIcmp: true,
            useSyn: false,
            synPort: "",
            destinationIps: ""
        },
        spmApiKey: "",
        logInState: Visonum_BulkPingApp_Components_App_Types.LoginNotTried.value,
        details: Data_Maybe.Nothing.value,
        displayError: Data_Maybe.Nothing.value,
        pollingForkId: Data_Maybe.Nothing.value
    };
};
var cellsFromBulkPingResult = function (result) {
    return [ (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(Visonum_BulkPingApp_Util.dateTimeToStringISO8601(result.value0.value0.timestamp));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(printDuration(result.value0.value0.pingTimeMinMillis));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(printDuration(result.value0.value0.pingTimeAvgMillis));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(printDuration(result.value0.value0.pingTimeMedianMillis));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(printDuration(result.value0.value0.pingTimeMaxMillis));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(printDuration(result.value0.value0.pingTimeStdDevJitterMillis));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingSuccess) {
            return new Data_Maybe.Just(printDuration(result.value0.value0.pingTimeTR143JitterMillis));
        };
        return Data_Maybe.Nothing.value;
    })(), (function () {
        if (result instanceof Data_Maybe.Just && result.value0 instanceof Visonum_API_SpeedMaster.BulkPingError) {
            return new Data_Maybe.Just(result.value0.value0.message);
        };
        if (result instanceof Data_Maybe.Nothing) {
            return new Data_Maybe.Just("N/A");
        };
        return Data_Maybe.Nothing.value;
    })() ];
};
var pingsToCsv = function (entries) {
    var mkRow = function (v) {
        return append1([ new Data_Maybe.Just(v.destination) ])(append1(cellsFromBulkPingResult(v.timeIcmp))(cellsFromBulkPingResult(v.timeSyn)));
    };
    return {
        headers: [ "Destination IP", "ICMP Timestamp", "ICMP Min (ms)", "ICMP Avg (ms)", "ICMP Median (ms)", "ICMP Max (ms)", "ICMP StdDev Jitter (ms)", "ICMP TR143 Jitter (ms)", "ICMP Error", "TCP SYN Timestamp", "TCP SYN Min (ms)", "TCP SYN Avg (ms)", "TCP SYN Median (ms)", "TCP SYN Max (ms)", "TCP SYN StdDev Jitter (ms)", "TCP SYN TR143 Jitter (ms)", "TCP SYN Error" ],
        rows: map(mkRow)(entries)
    };
};
var handleAction = function (ac) {
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.Initialize) {
        return bind(liftEffect(function __do() {
            var win = Web_HTML.window();
            var store = Web_HTML_Window.localStorage(win)();
            return Web_Storage_Storage.getItem("key")(store)();
        }))(function (mayKey) {
            if (mayKey instanceof Data_Maybe.Just) {
                return discard(modify_(function (state) {
                    var $103 = {};
                    for (var $104 in state) {
                        if ({}.hasOwnProperty.call(state, $104)) {
                            $103[$104] = state[$104];
                        };
                    };
                    $103.spmApiKey = mayKey.value0;
                    $103.logInState = Visonum_BulkPingApp_Components_App_Types.LoginSuccess.value;
                    return $103;
                }))(function () {
                    return startPolling;
                });
            };
            if (mayKey instanceof Data_Maybe.Nothing) {
                return pure(Data_Unit.unit);
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 126, column 7 - line 133, column 29): " + [ mayKey.constructor.name ]);
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.Finalize) {
        return stopPolling;
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.HideError) {
        return modify_(function (state) {
            var $107 = {};
            for (var $108 in state) {
                if ({}.hasOwnProperty.call(state, $108)) {
                    $107[$108] = state[$108];
                };
            };
            $107.displayError = Data_Maybe.Nothing.value;
            return $107;
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.UpdateJobInput) {
        return modify_(function (state) {
            var $110 = {};
            for (var $111 in state) {
                if ({}.hasOwnProperty.call(state, $111)) {
                    $110[$111] = state[$111];
                };
            };
            $110.newJob = ac.value0;
            return $110;
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.DownloadResults) {
        return bind(get)(function (state) {
            return bind(liftEffect(Effect_Random.randomInt(0)(top)))(function (c) {
                return bind(liftAff(Visonum_API_SpeedMaster.getBulkPingResult(state.staticConfig.speedMasterUrl)(state.spmApiKey)({
                    jobId: ac.value0,
                    c: c
                })))(function (result) {
                    if (result instanceof Data_Either.Left) {
                        return showError("Failed to fetch Result")(show(result.value0));
                    };
                    if (result instanceof Data_Either.Right) {
                        if (ac.value1 instanceof Visonum_BulkPingApp_Components_App_Types.DownloadJson) {
                            var json = Data_Codec.encode(Visonum_API_SpeedMaster.codecBulkPingResultResponse)(result.value0);
                            var str = Data_Argonaut_Core.stringify(json);
                            return liftEffect(function () {
                                return $foreign.download("bulk-ping-" + (ac.value0 + ".json"), str);
                            });
                        };
                        if (ac.value1 instanceof Visonum_BulkPingApp_Components_App_Types.DownloadCsv) {
                            var csv = pingsToCsv(result.value0.results);
                            var str = Visonum_BulkPingApp_CSV.printCsv(csv);
                            return liftEffect(function () {
                                return $foreign.download("bulk-ping-" + (ac.value0 + ".csv"), str);
                            });
                        };
                        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 152, column 11 - line 161, column 87): " + [ ac.value1.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 148, column 7 - line 161, column 87): " + [ result.constructor.name ]);
                });
            });
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.SetShowNewJob) {
        return modify_(function (state) {
            var $120 = {};
            for (var $121 in state) {
                if ({}.hasOwnProperty.call(state, $121)) {
                    $120[$121] = state[$121];
                };
            };
            $120.showNewJob = ac.value0;
            return $120;
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.ShowDetails) {
        return discard(modify_(function (state) {
            var $124 = {};
            for (var $125 in state) {
                if ({}.hasOwnProperty.call(state, $125)) {
                    $124[$125] = state[$125];
                };
            };
            $124.details = new Data_Maybe.Just({
                jobId: ac.value0,
                result: Data_Maybe.Nothing.value
            });
            return $124;
        }))(function () {
            return bind(get)(function (state) {
                return bind(liftEffect(Effect_Random.randomInt(0)(top)))(function (c) {
                    return bind(liftAff(Visonum_API_SpeedMaster.getBulkPingResult(state.staticConfig.speedMasterUrl)(state.spmApiKey)({
                        jobId: ac.value0,
                        c: c
                    })))(function (resp) {
                        return discard((function () {
                            if (resp instanceof Data_Either.Left) {
                                return showError("Failed to fetch Result")(show(resp.value0));
                            };
                            if (resp instanceof Data_Either.Right) {
                                return pure(Data_Unit.unit);
                            };
                            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 174, column 7 - line 178, column 20): " + [ resp.constructor.name ]);
                        })())(function () {
                            return modify_(function (v) {
                                var $130 = {};
                                for (var $131 in v) {
                                    if ({}.hasOwnProperty.call(v, $131)) {
                                        $130[$131] = v[$131];
                                    };
                                };
                                $130.details = new Data_Maybe.Just({
                                    jobId: ac.value0,
                                    result: new Data_Maybe.Just(resp)
                                });
                                return $130;
                            });
                        });
                    });
                });
            });
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.HideDetails) {
        return modify_(function (state) {
            var $134 = {};
            for (var $135 in state) {
                if ({}.hasOwnProperty.call(state, $135)) {
                    $134[$135] = state[$135];
                };
            };
            $134.details = Data_Maybe.Nothing.value;
            return $134;
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.SubmitNewJob) {
        return bind(get)(function (st) {
            var result = Visonum_BulkPingApp_Components_App_Types.parseInputVals(st.newJob);
            if (result instanceof Data_Either.Left) {
                return showError("Invalid input")(show1(result.value0));
            };
            if (result instanceof Data_Either.Right) {
                return discard(modify_(function (state) {
                    var $139 = {};
                    for (var $140 in state) {
                        if ({}.hasOwnProperty.call(state, $140)) {
                            $139[$140] = state[$140];
                        };
                    };
                    $139.showNewJob = false;
                    return $139;
                }))(function () {
                    return bind(liftAff(Visonum_API_SpeedMaster.postBulkPingStart(st.staticConfig.speedMasterUrl)(st.spmApiKey)(result.value0)))(function (startResult) {
                        return discard((function () {
                            if (startResult instanceof Data_Either.Left) {
                                return showError("Failed to start job")(show(startResult.value0));
                            };
                            if (startResult instanceof Data_Either.Right) {
                                return pure(Data_Unit.unit);
                            };
                            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 194, column 11 - line 198, column 24): " + [ startResult.constructor.name ]);
                        })())(function () {
                            return pure(Data_Unit.unit);
                        });
                    });
                });
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 188, column 7 - line 199, column 20): " + [ result.constructor.name ]);
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.SetPassword) {
        return modify_(function (state) {
            var $146 = {};
            for (var $147 in state) {
                if ({}.hasOwnProperty.call(state, $147)) {
                    $146[$147] = state[$147];
                };
            };
            $146.spmApiKey = ac.value0;
            return $146;
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.Login) {
        return discard(modify_(function (state) {
            var $150 = {};
            for (var $151 in state) {
                if ({}.hasOwnProperty.call(state, $151)) {
                    $150[$151] = state[$151];
                };
            };
            $150.logInState = Visonum_BulkPingApp_Components_App_Types.LoginChecking.value;
            return $150;
        }))(function () {
            return bind(runSinglePoll)(function (ok) {
                if (ok) {
                    return discard(modify_(function (state) {
                        var $154 = {};
                        for (var $155 in state) {
                            if ({}.hasOwnProperty.call(state, $155)) {
                                $154[$155] = state[$155];
                            };
                        };
                        $154.logInState = Visonum_BulkPingApp_Components_App_Types.LoginSuccess.value;
                        return $154;
                    }))(function () {
                        return bind(get)(function (st) {
                            return discard(liftEffect(function __do() {
                                var win = Web_HTML.window();
                                var store = Web_HTML_Window.localStorage(win)();
                                return Web_Storage_Storage.setItem("key")(st.spmApiKey)(store)();
                            }))(function () {
                                return startPolling;
                            });
                        });
                    });
                };
                return modify_(function (state) {
                    var $157 = {};
                    for (var $158 in state) {
                        if ({}.hasOwnProperty.call(state, $158)) {
                            $157[$158] = state[$158];
                        };
                    };
                    $157.logInState = Visonum_BulkPingApp_Components_App_Types.LoginFailure.value;
                    return $157;
                });
            });
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.Logout) {
        return discard(modify_(function (state) {
            var $160 = {};
            for (var $161 in state) {
                if ({}.hasOwnProperty.call(state, $161)) {
                    $160[$161] = state[$161];
                };
            };
            $160.logInState = Visonum_BulkPingApp_Components_App_Types.LoginNotTried.value;
            $160.spmApiKey = "";
            return $160;
        }))(function () {
            return discard(liftEffect(function __do() {
                var win = Web_HTML.window();
                var store = Web_HTML_Window.localStorage(win)();
                return Web_Storage_Storage.removeItem("key")(store)();
            }))(function () {
                return stopPolling;
            });
        });
    };
    if (ac instanceof Visonum_BulkPingApp_Components_App_Types.CancelJob) {
        return bind(get)(function (st) {
            return bind(liftAff(Visonum_API_SpeedMaster.postBulkPingCancel(st.staticConfig.speedMasterUrl)(st.spmApiKey)({
                jobId: ac.value0
            })))(function () {
                return pure(Data_Unit.unit);
            });
        });
    };
    throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 119, column 3 - line 236, column 16): " + [ ac.constructor.name ]);
};
var component = /* #__PURE__ */ (function () {
    return Halogen_Component.mkComponent({
        initialState: initialState,
        render: render,
        "eval": Halogen_Component.mkEval({
            handleQuery: Halogen_Component.defaultEval.handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            handleAction: handleAction,
            initialize: new Data_Maybe.Just(Visonum_BulkPingApp_Components_App_Types.Initialize.value),
            finalize: new Data_Maybe.Just(Visonum_BulkPingApp_Components_App_Types.Finalize.value)
        })
    });
})();
export {
    Void,
    component
};
//# sourceMappingURL=index.js.map
